export default __webpack_public_path__ + "static/media/front_connect.23f20738.svg";